import { CardContent, Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const btnSx = { width: { xs: '100%', md: 'auto' }, flexShrink: 0 };

interface CardRowsProps {
  label: string;
  desc?: string;
  value: ReactNode | null;
  action?: ReactNode;
  color?: 'primary' | 'error';
}
export const CardRows = ({ label, desc, value = null, action, color = 'primary' }: CardRowsProps) => {
  return (
    <CardContent sx={{ p: 5 }}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={value ? 4 : 10} sx={{ display: 'flex', flexFlow: 'column', alignItems: 'start', justifyContent: 'center' }}>
          <Typography variant="h5" color={color}>
            {label}
          </Typography>
          {desc && <Typography variant="body2">{desc}</Typography>}
        </Grid>
        {value && (
          <Grid
            item
            xs={12}
            md={action ? 6 : 8}
            sx={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
              gap: 2,
              flexDirection: { md: 'row', xs: 'column' },
            }}
          >
            {value}
          </Grid>
        )}
        {action && (
          <Grid
            item
            xs={12}
            md={2}
            sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
          >
            {action}
          </Grid>
        )}
      </Grid>
    </CardContent>
  );
};
